import React, { useContext, useState, useEffect } from "react";
import { collection, doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../firebaseconfig";
import { Navigate, useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

export const DisplayResults = () => {

    const navigate = useNavigate()

    const { user, loading } = useContext(AuthContext)

    const [admin, setAdmin] = useState(false)

    const [votes, setVotes] = useState([]);
    const [status, setStatus] = useState('loading');
  
    useEffect(() => {
    
        // If user is still loading, return early to avoid bad rendering
        if (loading) {
            return
        }

        //Check if user is admin
        if (user) {
            if (user.uid === "mislOlSGa1Opj6uLWi8ISZFcF9q1") {
                setAdmin(true)
            } else {
                setAdmin(false)
                setStatus('success')
                return
            }
        } else {
            setAdmin(false)
            setStatus('success')
            return
        }

        //Create a listener to the judges collection for votes
        const unsubscribe = onSnapshot(
            collection(db, "judges"), 
            async(snapshot) => {

                const agg = {}

                // Loop through each document in the collection and aggregate the votes for each candidate
                snapshot.forEach(doc => {
                    const docData = doc.data().votes
                    Object.entries(docData).forEach(([id, {points_given}]) => {
                        agg[id] = (agg[id] || 0) + (points_given || 0)
                    })
                })
                
                // Get the candidate data from the candidates collection and map it to the aggregated votes
                const data = (await getDoc(doc(db, "candidates", "1"))).data()
                const arr = Object.entries(agg).map(([id, points]) => ({ id, points, name: data[id].name, play: data[id].play }))

                // Sort the candidates by points in descending order
                arr.sort((a, b) => b.points - a.points)

                setVotes(arr);
                setStatus('success');

            },
                (error) => {
                alert("Error fetching data")
                setStatus('error')
                console.error(error)
            }
        );
    
        // 3) Clean up when component unmounts:
        return () => unsubscribe();
    }, [loading, user]);
    
    // If user is still loading, return early to avoid bad rendering
    if (status === 'loading') return <p>Loading…</p>;

    // If error occurs, redirect to home page
    if (status === 'error') {
        navigate("/", {replace: true})
    };
        
    return(

        admin ? (
            <div className="main-container results-page">

                <h1 className="main-title-text results-title">Élő Eredmények</h1>

                <div className="vote-display-container">

                    {votes.map((item, index) => {

                        const shouldInsertDivider = (index) => index === 1 || index === 3;

                        return (

                            <>
                            <div key={item.id} className="results-row">
                                <span className="rank-number">{index+1}</span>

                                <div className="candidate-container result-card">
                                    <div className="candidate-name-container">
                                        <h3>{item.name}</h3>
                                    </div>
                                    <div className="candidate-play-container">
                                        <p>{item.play}</p>
                                    </div>
                                    <div className="candidate-points-container">
                                        <h3>{item.points}</h3>
                                    </div>
                                </div>

                            </div>
                            {shouldInsertDivider(index) && <hr className="results-divider" />}
                            </>

                        )
                    })

                    }

                </div>

            </div>) : (

            <Navigate to="/" replace/>

        )

    )

}